import { EntityType } from "@mapmycustomers/shared/enum";

const OptionEntityTypes = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
  EntityType.ACTIVITY,
];

export default OptionEntityTypes;
